export const LETTER_MAX_LENGTH = 4;

export const QUEUE_SIZE = 7;

export const FIBONACCI_MAX_INDEX = 19;

export const STRING_MAX_LENGTH = 11;

export const ARRAY_MIN_LENGTH = 3;

export const ARRAY_MAX_LENGTH = 17;

export const ARRAY_MIN_VALUE = 1;

export const ARRAY_MAX_VALUE = 100;

export const LIST_MIN_LENGTH = 3;

export const LIST_MAX_LENGTH = 6;

export const LIST_MIN_VALUE = 1;

export const LIST_MAX_VALUE = 100;
